import { useSyncExternalStore } from 'react';

/**
 * **Le sfide di piattaforma su cui il giocatore ha GIA' AGITO, su QUESTO dispositivo** (Accetta,
 * Rifiuta, o «non c'e' piu'»). Uno store di MODULO, non di componente: la barra non deve rimettere in
 * offerta una sfida gia' risolta quando il provider si rimonta (la serratura che va giu' e su, un logout e
 * un login) con la lista ancora vecchia che la dice `pending` (bloccante 2 di #489). Dura quanto la
 * pagina: un ricaricamento riparte da vuoto, e li' vale la lettura del server, che e' gia' quella
 * effettiva.
 */
let gestite: ReadonlySet<string> = new Set();
const ascoltatori = new Set<() => void>();

export function segnaSfidaGestita(challengeId: string): void {
  if (gestite.has(challengeId)) return;
  // Un Set NUOVO a ogni cambio: `useSyncExternalStore` confronta per riferimento.
  gestite = new Set(gestite).add(challengeId);
  ascoltatori.forEach((f) => f());
}

const leggi = () => gestite;
const iscrivi = (f: () => void) => {
  ascoltatori.add(f);
  return () => ascoltatori.delete(f);
};

/** Gli id (`challengeId`) gestiti qui, con re-render a ogni nuovo. */
export function useSfideGestite(): ReadonlySet<string> {
  return useSyncExternalStore(iscrivi, leggi, leggi);
}

/** Solo per i test: un file di test non deve ereditare le sfide gestite del precedente. */
export function azzeraSfideGestitePerTest(): void {
  gestite = new Set();
  ascoltatori.forEach((f) => f());
}
